import styled from 'styled-components';
import image from '../../../images/banner-background.png';
export const BannerWrapper = styled.div`

background-size: cover;
background-position: center;
margin-top: 69px;
height: 120px;
font-family: 'Noto Sans', sans-serif;
width:100%;
background: url('${image}') ;
.bannerContent{
    display: flex;
    justify-content: center;
    height: 58%;
    color: #fff;
    .bannerText{
        h3{
            font-size: 22px;
            margin: 0;
            padding-bottom:0px;
            font-weight: 600;
        }
        p{
            font-size: 14px;
        }
    }
}
`;